import { useTranslation } from '../../../../../../i18n/hooks/useTranslation';
import ZodiacIcon from './ZodiacIcon';

export default function RashifolCard({ signId, data, lang }) {
    const { t } = useTranslation();
    const isBn = lang === 'bn';
    const name = isBn ? data.name_bn : data.name_en;
    const dates = isBn ? data.dates_bn : data.dates_en;
    const element = isBn ? data.element_bn : data.element_en;
    const traits = isBn ? data.traits_bn : data.traits_en;
    const rashifol = isBn ? data.rashifol_bn : data.rashifol_en;

    return (
        <div
            data-export-rashifol-box
            className="overflow-hidden rounded-xl border border-[#E8E8EE] bg-white dark:border-zinc-700 dark:bg-zinc-900"
        >
            <div className="flex items-center gap-2.5 border-b border-violet-200 bg-violet-50 px-3.5 py-2.5 dark:border-violet-900/40 dark:bg-violet-950/20">
                <span className="grid h-8 w-8 flex-none place-items-center rounded-lg border border-violet-200 bg-white dark:border-violet-900/40 dark:bg-zinc-900">
                    <ZodiacIcon id={signId} size={20} color="#7C3AED" />
                </span>
                <p className="text-[12px] font-bold leading-tight text-violet-800 dark:text-violet-300">
                    {t('ageCalculator.rashifolTitle')}
                </p>
            </div>

            <div className="flex flex-wrap items-start gap-4 px-3.5 py-4">
                <div
                    data-export-rashifol-icon
                    className="grid h-[72px] w-[72px] flex-none place-items-center rounded-[14px] border-[1.5px] border-violet-200 bg-violet-50 dark:border-violet-900/40 dark:bg-violet-950/20"
                >
                    <ZodiacIcon id={signId} size={44} color="#7C3AED" />
                </div>

                <div className="min-w-[200px] flex-1">
                    <p
                        data-export-rashifol-sign
                        className="mb-1 text-[20px] font-black leading-tight text-violet-800 dark:text-violet-300"
                    >
                        {name}
                    </p>
                    <p className="mb-2.5 text-[11px] font-semibold text-[#6B6B75] dark:text-zinc-400">
                        {dates} · {t('ageCalculator.rashifolElement')}: {element}
                    </p>

                    <span className="mb-3 inline-flex rounded-full border border-violet-200 bg-violet-50 px-2.5 py-1 text-[11px] font-semibold text-violet-800 dark:border-violet-900/40 dark:bg-violet-950/20 dark:text-violet-300">
                        {t('ageCalculator.rashifolTraits')}: {traits}
                    </span>

                    <p
                        data-export-rashifol-text
                        className="text-[13px] font-medium leading-relaxed text-[#1B1B1F] dark:text-zinc-200"
                    >
                        {rashifol}
                    </p>
                </div>
            </div>

            <p
                data-export-rashifol-footer
                className="border-t border-[#F0F0F6] bg-[#FAFAFC] px-3.5 py-2.5 text-center text-[11px] italic text-[#6B6B75] dark:border-zinc-800 dark:bg-zinc-950 dark:text-zinc-500"
            >
                {t('ageCalculator.rashifolFooter')}
            </p>
        </div>
    );
}
